module.exports = __webpack_public_path__ + "static/img/TimerPlaying.1851d897.png";